import { useState } from 'react'
import { Form } from './useForm'

export type Errors = Record<string, string>

const useDataError = (form: Form) => {
  const [errors, setErrors] = useState<Errors>({})

  const parseDate = (dateString: string | undefined): Date | null => {
    if (!dateString) return null
    const [year, month, day] = dateString.split('-').map(Number)
    return new Date(year, month - 1, day)
  }

  const validateFields = () => {
    const birthDate = parseDate(form.birth)
    const deathDate = parseDate(form.death)
    const newErrors: Errors = {}
    const today = new Date()

    if (!form.name.trim()) {
      newErrors.name = 'Imię i nazwisko są wymagane'
    }
    if (!form.birth) {
      newErrors.birth = 'Data urodzenia jest wymagana'
    }
    if (!form.death) {
      newErrors.death = 'Data śmierci jest wymagana'
    }

    if (deathDate && birthDate) {
      if (deathDate > today) {
        newErrors.death = 'Data śmierci nie może być późniejsza niż dzisiaj'
      
      } else if (birthDate > today) {
        newErrors.birth = 'Data urodzenia nie może być późniejsza niż dzisiaj'
      
      } else if (deathDate < birthDate) {
        newErrors.birth = 'Data urodzin nie może być późniejsza niż data śmierci'
        newErrors.death = 'Data śmierci nie może być wcześniejsza niż data urodzin'
      }
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  return {
    errors,
    validateFields
  }
}

export default useDataError